/// <reference path="../../app.definition.ts" />

import { SearchResult } from "./searchResult";
import { Serializable } from "./Serializable";

export class ViewState implements Serializable<ViewState> {
    viewId: string;

    deserialize(input?) {
        !!input.viewId && (this.viewId = input.viewId);
        return this;
    }

    constructor(input?) {
        !!input && this.deserialize(input);
    }
}

export class SearchState extends ViewState {
    page: number;
    scrollTop: number;
    filters: SearchResult;
    params: SearchResult;
    sortKey: string;
    sortDir: string;
    startIndex: number;
    endIndex: number;

    deserialize(input) {
        !!input && super.deserialize(input);
        this.page = input.page || 0;
        !!input.scrollTop && (this.scrollTop = input.scrollTop);
        !!input.startIndex && (this.startIndex = input.startIndex);
        !!input.endIndex && (this.endIndex = input.endIndex);
        !!input.filters && (this.filters = new SearchResult(input.filters));
        !!input.sortKey && (this.sortKey = input.sortKey);
        !!input.sortDir && (this.sortDir = input.sortDir);
        !!input.params && (this.params = new SearchResult(input.params));
        return this;
    }

    constructor(input?) {
        super(input);
        !!input && this.deserialize(input);
    }
}
